import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { CompanyProvider } from '../../../contexts/CompanyContext';
import { PermissionProvider } from '../../../contexts/PermissionContext';
import BaseSidebarLayout from '../shared/BaseSidebarLayout';
import MerchantSidebar from './MerchantSidebar';
import MissingMerchantAliasBanner from '../../company/settings/MissingMerchantAliasBanner';

/**
 * MerchantLayout - Complete standalone layout for merchant users
 *
 * This layout wraps BaseSidebarLayout with merchant-specific context providers:
 * - CompanyProvider: Company and employee context
 * - PermissionProvider: Permission checking for UI access control
 *
 * The MerchantSidebar component is passed to BaseSidebarLayout and renders
 * INSIDE the PermissionProvider, giving it access to permission context.
 *
 * Architecture:
 * - Completely self-contained (header, sidebar, content, footer)
 * - No dependencies on App.js for layout
 * - Permission-aware sidebar navigation
 * - Consistent with SO layout (same base component)
 */
const MerchantLayout = () => {
  const { activeCompanyId } = useAuth();

  return (
    <CompanyProvider>
      <PermissionProvider>
        <BaseSidebarLayout
          SidebarContent={MerchantSidebar}
          storageKey="merchantSidebarOpen"
          topBanner={<MissingMerchantAliasBanner />}
        >
          <Outlet key={activeCompanyId} />
        </BaseSidebarLayout>
      </PermissionProvider>
    </CompanyProvider>
  );
};

export default MerchantLayout;
